import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { storeUserData } from "../store/userSlice";
import { RootState } from "../store";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LOGO2 from "../assets/images/newLogo.png";
import APPNAME from "../assets/images/appname.png";
import { useAppDispatch } from "../hooks/useRedux";

const Welcome = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { loading } = useSelector((state: RootState) => state.user);

  const handleRegister = async () => {
    if (location.state?.userInfo) {
      try {
        await dispatch(storeUserData(location.state.userInfo));
        navigate("/feeds");
        // toast.success("Profile loaded successfully");
      } catch (error) {
        console.error(error);
        toast.error("Failed to load profile");
      }
    } else {
      toast.error("No user information found");
    }
  };

  return (
    <div className="min-h-screen bg-[#121212] text-white px-4 py-8 flex items-center justify-center">
      <ToastContainer />
      <div className="max-w-xl mx-auto text-center">
        <img
          src={LOGO2}
          alt="logo"
          className="h-40 w-40 object-contain mx-auto mb-4"
        />
        <img
          src={APPNAME}
          alt="app name"
          className="h-14 object-contain mx-auto mb-6"
        />
        <h2 className="text-3xl font-semibold uppercase text-white mb-4">
          You Have Been Portalized!
        </h2>
        <p className="text-sm text-gray-300 mb-4 mx-1">
          Coaches and other athletes can now view your profile and stats.
          Registered coaches for your sport have been automatically notified of
          your entry into the transfer portal.
        </p>
        <p className="text-sm text-gray-300 mb-6 mx-1">
          You should now go to your profile and add any achievements you may
          have. This can be any sports or academic achievements such as GPA.
        </p>
        <div className="w-full flex justify-center">
          <button
            onClick={handleRegister}
            disabled={loading}
            className="w-full max-w-md bg-[#C00000] hover:bg-red-700 text-white py-3 rounded-md font-semibold transition"
          >
            {loading ? "Loading..." : "GO TO YOUR PROFILE"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
